export const isFinanced = paymentOption => paymentOption?.value === 'financed';
